import { CircularProgress } from '@mui/material'
import { FlexBoxColumn } from 'components/atoms'
import { BetSection, ErrorSection, HeaderSection } from 'components/organisms'
import { useBetContext } from 'contexts/BetContext'
import {
    LANG,
    TLanguage,
    TranslationContext
} from 'contexts/TranslationContext'
import { useSession } from 'hooks'
import { useContext, useEffect, useState } from 'react'
import { getQueryParam } from 'utils/url'

export const BetSlip = () => {
    const [loading, setLoading] = useState(true)
    const [windowOpened, setWindowOpened] = useState(false)
    const { error, race, handleTrackingEvent } = useBetContext()
    const { setLanguage } = useContext(TranslationContext)

    const animationDelay = 300
    const loadingComplete = race || error
    const language = (getQueryParam('lang') || 'fr') as TLanguage

    useEffect(() => {
        if (language && LANG.includes(language)) setLanguage(language)
    }, [])

    useEffect(() => {
        useSession()
        if (loadingComplete)
            setTimeout(() => {
                setLoading(false)
                !windowOpened &&
                    handleTrackingEvent({
                        eventType: 'WINDOW',
                        actionType: error ? 'ERROR' : 'OPEN'
                    })
                setWindowOpened(true)
            }, animationDelay)
    }, [race, error, windowOpened])

    return (
        <>
            {loading && (
                <FlexBoxColumn
                    sx={{
                        width: '100vw',
                        height: '100vh',
                        overflowX: 'hidden',
                        position: 'absolute',
                        zIndex: 10,
                        backgroundColor: 'white',
                        justifyContent: 'center',
                        transition: `opacity ${animationDelay}ms ease-in-out`,
                        opacity: !loadingComplete ? 1 : 0
                    }}
                >
                    <CircularProgress />
                </FlexBoxColumn>
            )}

            <FlexBoxColumn
                sx={{
                    width: '100vw',
                    minHeight: '100vh',
                    overflowX: 'hidden',
                    justifyContent: 'flex-start'
                }}
            >
                <HeaderSection />
                {race && !error ? (
                    <BetSection />
                ) : (
                    <ErrorSection error={error || 'Service indisponible.'} />
                )}
            </FlexBoxColumn>
        </>
    )
}
